// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderSearchStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch";
import { xScreen } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = {
    searchGridItem: {
        width: [12, 12, 4, 5, 5],
        css: css`
            position: relative;
            align-items: flex-end;
        `,
    },
    qtyGridItem: {
        width: [3, 3, 2, 1, 1],
        css: css`
            align-items: flex-end;
        `,
    },
    unitOfMeasureGridItem: {
        width: [9, 9, 3, 3, 3],
        css: css`
            align-items: flex-end;
        `,
    },
    buttonGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            align-items: flex-end;
        `,
    },
    clearIcon: {
        css: css`
            position: absolute;
            right: 32px;
            top: 43px;
            cursor: pointer;
            ${xScreen("lte", "sm")} {
                top: 34px;
            }
        `,
    },
    searchDynamicDropdown: {
        cssOverrides: {
            selectedText: css`
                width: calc(100% - 45px);
            `,
        },
    },
};
